import { Talent } from "src/types";
import { capitalize } from "src/utils/strings";

export class TalentClass {
  talent: Talent;
  constructor(data: Talent) {
    this.talent = data;
  }

  salaryText() {
    if (!this.talent.hourly_rate) return "";
    return `$${this.talent.hourly_rate}/hr`;
  }

  yearsText() {
    if (!this.talent.years_of_experience) return "";
    return `${this.talent.years_of_experience} Years`;
  }

  jsonToText(j) {
    return JSON.parse(j)
      .map(({ value }) => capitalize(value))
      .join(", ");
  }

  openToText() {
    try {
      return this.jsonToText(this.talent.roles_open_to);
    } catch {
      return "";
    }
  }

  termToText() {
    try {
      return this.jsonToText(this.talent.terms_open_to);
    } catch {
      return "";
    }
  }

  primarySkills() {
    return this.talent?.skills.filter((s) => s.freelancer_skill?.is_primary);
  }

  primarySkillsNames() {
    return this.primarySkills().map((s) => s.name);
  }
}
